import React, { useEffect, useState } from "react";

import { isMobile } from "react-device-detect";
import _ from "lodash";
import SliderItem from "./SliderItem";

import { Helmet } from "react-helmet-async";
import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function Slider(props) {
  const [swiperRef, setSwiperRef] = useState(null);
  const [video, setVideo] = useState({});
  const [image, setImage] = useState({});
  // برای فعال کردن/غیرفعال کردن pagination
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (props.images && props.images.length > 0) {
      const imageSel = props.images.filter((a) => a.gallery.option === 1)[0];
      if (imageSel) {
        // جهت پیدا کردن سایز عکس
        const img1 = new Image();
        img1.src = process.env.REACT_APP_API_URL + imageSel.gallery.imageUrl;
        img1.onload = function () {
          imageSel.width = this.width;
          imageSel.height = this.height;
          setImage(imageSel); // به روزرسانی حالت image پس از بارگذاری تصویر
        };
      } else {
        setImage({});
      }
      setVideo(props.images.filter((a) => a.gallery.option === 2)[0]); // ویدئو
    }
  }, [props.images]);

  useEffect(() => {}, [image, video]);

  return (
    <>
      <div className="wrapper">
        <Helmet>
          <meta
            property="og:image"
            content={
              image?.gallery?.imageUrl
                ? `${process.env.REACT_APP_API_URL}${image.gallery.imageUrl}`
                : ""
            }
          />
          <meta
            property="og:image:width"
            content={image?.width?.toString() || ""}
          />
          <meta
            property="og:image:height"
            content={image?.height?.toString() || ""}
          />
          <meta
            property="og:video"
            content={
              video?.gallery?.imageUrl
                ? `${process.env.REACT_APP_API_URL}${video.gallery.imageUrl}`
                : ""
            }
          />
        </Helmet>
      </div>
      <div
        id="slider"
        className=" py-0 "
        // style={isMobile ? { height: "270px" } : { height: "300px" }}
      >
        <Swiper
          // style={isMobile ? { height: "270px" } : { height: "300px" }}
          onSwiper={setSwiperRef}
          loop={true}
          spaceBetween={15}
          className="mySwiper rounded-4 swiper-with-arrow amusement-detail"
          modules={[Navigation, Pagination]}
          pagination={
            props?.images[activeIndex]?.gallery.option === 1
              ? { type: "fraction" }
              : false
          }
          navigation={true}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        >
          <>
            {props?.images?.map((ItemData, index) => (
              <SwiperSlide key={index}>
                <SliderItem
                  ItemData={ItemData}
                  index={index}
                  amusementNameText={props.amusementNameText}
                />
              </SwiperSlide>
            ))}
          </>
        </Swiper>
      </div>
    </>
  );
}

export default Slider;
